/* tslint:disable */

/**
 */
export class MachineDeviceStatus {
    timestamp?: number;
    status_device?: string;
}
